import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
const {FiArrowUpRight,FiCheck}=FiIcons;
function Bridal() {
  return (
    <section className="bridal-section" id="bridal">
      <div className="container bridal-grid">
        <Reveal className="bridal-image">
          <img src="https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/b3e3af91805d92bff3f2734f178b145b.webp" alt="Bridal beauty at Saffron & Sage Salon" />
          <span className="image-caption">YOUR DAY,YOUR KIND OF BEAUTIFUL</span>
        </Reveal>
        <Reveal className="bridal-copy" delay={0.1}>
          <span className="eyebrow eyebrow-gold">For the moments that matter</span>
          <h2>Beauty that feels<br /><em>like you.</em></h2>
          <p>From the first trial to the final touch,our makeup artists make space for your vision,your traditions and every little detail in between.</p>
          <ul>{['Bridal makeup & hair','Engagement makeup','Party makeup','Pre-bridal services'].map(item=> <li key={item}><SafeIcon icon={FiCheck} />{item}</li>)}</ul>
          <a className="button button-gold" href="#appointment">Book Bridal Consultation <SafeIcon icon={FiArrowUpRight} /></a>
        </Reveal>
      </div>
    </section>
  );
}
export default Bridal;
